import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Button } from "primereact/button";
import ReportsMessages from "reports/intl/ReportsMessages";
import DataExportListStore$ from "reports/data-export/data-export-list/stores/DataExportListStore";

const handleCancel = () => {
  DataExportListStore$.selection.set(null);
};

const RightContent = ({ isSending }) => {
  const { formatMessage } = useIntl();
  return (
    <Button
      disabled={isSending}
      label={formatMessage(ReportsMessages.cancel)}
      link
      onClick={handleCancel}
    />
  );
};

RightContent.propTypes = {
  isSending: PropTypes.bool,
};

export default RightContent;
